var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { color: "transparent", "show-arrows": "" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("v-tabs-slider", { attrs: { color: "primary" } }),
          _vm._v(" "),
          _vm._l(_vm.tabs, function(tabItem) {
            return _c("v-tab", { key: tabItem }, [
              _vm._v("\n        " + _vm._s(tabItem) + "\n      ")
            ])
          }),
          _vm._v(" "),
          _c(
            "v-tabs-items",
            {
              attrs: { touchless: "" },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            _vm._l(2, function(item, index) {
              return _c(
                "v-tab-item",
                { key: "item" + index },
                [
                  _vm.tab === index
                    ? _c("MemberTable", {
                        attrs: {
                          showAddGroupDialog: _vm.showAddGroupDialog,
                          users: _vm.getData(),
                          isRealtime: _vm.tab === 1 && index === 1,
                          type: _vm.type,
                          firstActionText: _vm.firstActionText,
                          firstFunc: _vm.firstFunc,
                          secondActionText: _vm.secondActionText,
                          secondFunc: _vm.secondFunc,
                          showAddGroupButton: index === 1,
                          addGroupFunc: _vm.showAddGroupDialog
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _vm.editOfferDialog
        ? _c("MemberEdit", {
            attrs: {
              title: _vm.$t("editUser"),
              isUser: true,
              isEditGroup: false,
              user: _vm.userInEdit
            },
            model: {
              value: _vm.editOfferDialog,
              callback: function($$v) {
                _vm.editOfferDialog = $$v
              },
              expression: "editOfferDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editGroupDialog
        ? _c("MemberEdit", {
            attrs: {
              title: _vm.$t("editGroup"),
              isUser: false,
              isEditGroup: _vm.isEditGroup,
              type: _vm.type,
              group: _vm.groupInEdit
            },
            model: {
              value: _vm.editGroupDialog,
              callback: function($$v) {
                _vm.editGroupDialog = $$v
              },
              expression: "editGroupDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c7e3586c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7e3586c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Member.vue
// module id = null
// module chunks = 